<template>
  <div>
    <CompanyItem
      v-for="company in companyData.filter((c) => !!c)"
      :key="company.Code"
      :name="company.Name"
      :data="company"
      :highlightedText="companySearchKeyword"
      :searchedDocument="documentSearchKeyword"
    />
  </div>
</template>

<script>
import CompanyItem from "./CompanyItem.vue";
import Loading from "./Loading.vue";

export default {
  components: { CompanyItem, Loading },
  name: "ListBody",
  props: {
    companyData: {
      type: Array,
    },
    companySearchKeyword: {
      type: String,
    },
    documentSearchKeyword: {
      type: String,
    },
  },
};
</script>

<style></style>
